export default __webpack_public_path__ + "static/media/background.d54e030b.svg";